var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearningmanagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.125C10.5 25.7083 8.78125 24.625 6.84375 23.875C4.90625 23.125 2.875 22.75 0.75 22.75V9C2.85417 9 4.875 9.38 6.8125 10.14C8.75 10.9008 10.4792 12 12 13.4375C13.5208 12 15.25 10.9008 17.1875 10.14C19.125 9.38 21.1458 9 23.25 9V22.75C21.1042 22.75 19.0679 23.125 17.1413 23.875C15.2138 24.625 13.5 25.7083 12 27.125ZM12 10.25C10.625 10.25 9.44792 9.76042 8.46875 8.78125C7.48958 7.80208 7 6.625 7 5.25C7 3.875 7.48958 2.69792 8.46875 1.71875C9.44792 0.739583 10.625 0.25 12 0.25C13.375 0.25 14.5521 0.739583 15.5312 1.71875C16.5104 2.69792 17 3.875 17 5.25C17 6.625 16.5104 7.80208 15.5312 8.78125C14.5521 9.76042 13.375 10.25 12 10.25Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningmanagement);
export default __webpack_public_path__ + "static/media/learningmanagement.17c86b19505aee05ba98872413e09aa5.svg";
export { ForwardRef as ReactComponent };